export default {
  "meeting": {
    applyrecurring: 'השינויים יחולו על לוח הזמנים החוזר החדש. פגישות קודמות לא יושפעו.',
    recurrenceDescribeTwo: 'מתרחש כל {loopPulse} שבועות ב-{week}, החל מ-{start} ועד {end}',
    wanttodeletethemeetingfollowTwo: 'למחוק את הפגישה שנבחרה ואת כל הפגישות החוזרות שאחריה?',
    loopCycleSelectTips: 'בחר את היום בשבוע לחזרה.',
    export: 'ייצוא',
    exportMeetingFileFuncTipsTitle: 'אישור ייצוא',
    exportMeetingFileFuncTipsContentOne: 'לא הוחלו מסננים. המערכת תייצא כברירת מחדל את רשומות הפגישות של השנה הנוכחית.',
    exportMeetingFileFuncTipsContentTwo: 'כדי לייצא פגישות מתקופה אחרת, יש להחיל את המסננים הרצויים לפני הייצוא.',

    myMeetingSearch: 'הפגישות שלי',
    meetingTimeSearch: 'זמן הפגישה',
    meetingRoomsSearch: 'חדר ישיבות',

    Recurring: 'חוזר:',
    wanttodeletethemeetingfollow: 'האם אתה בטוח שברצונך למחוק פגישה זו ואת כל הפגישות הבאות?',
    endTimeCannotBeforeBeginTime: 'תאריך הסיום לא יכול להיות מוקדם מתאריך ההתחלה',
    Thismeeting: 'פגישה זו',
    Recurringmeeting: 'פגישה חוזרת',
    Checkin: 'צ׳ק-אין:',
    checkinTip: 'לאחר ההפעלה, המשתתפים יכולים לבצע צ׳ק-אין על ידי סריקת קוד ה-QR של מתזמן החדרים.',
    Recurrence_Setrecurrence: 'הגדרת חזרה',
    Recurrence_Start: 'התחלה',
    Recurrence_RepeatEvery: 'חזור כל',
    Recurrence_Week: 'שבוע',
    Recurrence_end: 'סיום',
    recurrenceDescribe: 'מתרחש כל {week} החל מ-{start} עד {end}',
    Recurrence_DoesnotRepeat: 'ללא חזרה',
    Recurrence_Weekly: 'שבועי',

    AddressBookUser: 'משתמש',
    AddressBookPhonebook: 'ספר כתובות',

    RoomByPeopleNum1: '2 אנשים או פחות',
    RoomByPeopleNum2: '3-6 אנשים',
    RoomByPeopleNum3: '7-10 אנשים',
    RoomByPeopleNum4: '11-15 אנשים',
    RoomByPeopleNum5: '16-20 אנשים',
    RoomByPeopleNum6: '21-30 אנשים',
    RoomByPeopleNum7: 'יותר מ-30 אנשים',

    whoAreBound: 'משתמשים המחוברים לחשבון מערכת יראו את הפגישה בלוח השנה של המערכת. משתמשים שהזינו אימייל יקבלו התראות בדוא״ל. לקבלת התראות, יש להשלים את הפרטים ב[הפרופיל שלי].',

    AttendessMeeting: 'משתתפים:',
    SelectAttendessMeetingTip: 'בחר משתתפים',

    MeetingFilter: 'סינון פגישות',
    HostedbyMe: 'אני המארח',
    Invitedby: 'אני משתתף',
    Otherby: 'אחרים',

    "AddressIsDuplicated": "כתובת האימייל של איש הקשר כפולה",
    "meetingExpired": "פג תוקף",
    titlePhoneFormat: 'ניתן להזין בטלפון רק מספרים, () + ו -.',
    "selectField": "אנא בחר קובץ",
    "Limit255": "שם הקובץ לא יכול לעלות על 255 תווים",
    "nameLimit25": "שם לא יכול לעלות על 25 תווים",
    "emailLimit50": 'דוא"ל לא יכול לעלות על 50 תווים',
    "emailFormatError": 'אנא הזן כתובת דוא"ל חוקית',
    "phoneLimit11": "מספר הטלפון יכול להכיל עד 11 ספרות",
    "ParticipantsEmail": 'דוא"ל המשתתף:',
    "listIsEmpty": "הרשימה ריקה",
    "Startimporting": "התחל העלאה",
    "Selectfile": "בחר קובץ",
    "Importfile": "ייבא קובץ",
    "ImportfileTip": "*תומך בייבוא קבצי CSV בפורמט Outlook ‏(*.csv) או קבצי vCard ‏(*.vcf) בלבד.",
    "addParticipants": "הוסף משתתף",
    "multiselectdeselect": "תזכורת למחיקת תווית",
    "multiselectselected": "תזכורת לבחירה",
    "enterOrSelectALabel": "בחר דוא\"ל של משתתף",
    "deleTitleContact": "האם אתה בטוח שברצונך למחוק איש קשר זה?",
    "delTitleContactContent": "למחוק איש קשר?",
    "deleteContactTitle": "אנא בחר את איש הקשר שברצונך למחוק",
    "editcontact": "ערוך איש קשר",
    "Name": "שם",
    "email": "דוא\"ל",
    "telephoneNumber": "טלפון",
    "Addcontact": "הוסף איש קשר",
    "Importcontactfile": "ייבא אנשי קשר",
    "AddressBook": "ספר כתובות",
    "Participants": "משתתפים:",

    "bindTipContent": "ארגון זה כבר מקושר ליומן צד שלישי. נא לקבוע פגישות דרך Outlook/Teams.",
    "Productupdatenews": "גרסת עדכון חדשה שוחררה.",
    "bookingPerson": "הוזמן על ידי",
    "DeleteMeeting": "מחק פגישה",
    "wanttodeletethemeeting": "האם ברצונך למחוק את הפגישה?",
    "hasbeendeleted": "הפגישה נמחקה",
    "theMeetingWasAborted": "סיים פגישה מוקדם",
    "theMeetingWasAbortedContent": "האם ברצונך לסיים את הפגישה מוקדם?",
    "determineTheAbortTask": "סיים פגישה מוקדם",
    "theMeetingEndedEarly": "הפגישה הסתיימה מוקדם",
    "with": "עם",
    "Other": "אחר",
    "tasks": "משימות",
    "conflict": "קונפליקט",
    "meetConflicts": "זמן הפגישה הבא מתנגש:",
    "itIsNotAllowedToSelectThePastTime": "לא ניתן לבחור זמנים בעבר",
    "selected": "נבחר",
    "noOverFive": "בחר לא יותר מ-5 חדרי פגישות",
    "approvalOpinions": "דעות אישור",
    "beyondTheTimeLimitItCannotBeSelected": "מעבר למגבלת הזמן, לא ניתן לבחור",
    "startMonth": "חודש התחלה",
    "to": "עד",
    "stopMonth": "חודש סיום",
    "didnTStart": "לא התחיל",
    "ONGOING": "בתהליך",
    "ENDED": "הסתיים",
    "hasBeen": "הוזמן",
    "booking": "הזמנה",
    "Approval": "אישור",
    "MeetingRoom": "חדר פגישות",
    "AllRoom": "כל החדרים",
    "Available": "זמין",
    "Initiate": "יזום פגישה",
    "MeetingApproval": "אישור פגישה",
    "PreviousMonth": "חודש קודם",
    "Today": "היום",
    "NextMonth": "חודש הבא",
    "YearMonth": "שנה/חודש",
    "TimeDisplay": "תצוגת זמן",
    "MeetingTitleAbbreviation": "קיצור שם הפגישה",
    "InitiateMeeting": "יזום פגישה",
    "PendingMeetings": "פגישות קרובות",
    "AllMeetings": "כל הפגישות",
    "noMeetings": "אין פגישות להשתתף כרגע",
    "NotStarted": "לא התחיל",
    "Organizer": "מארגן",
    "MeetingDateTime": "תאריך ושעה",
    "MeetingLocation": "מיקום",
    "MeetingSubject": "נושא הפגישה",
    "Invited": "מוזמנים",
    "PeopleAccepted": "אנשים שקיבלו",
    "EditMeeting": "ערוך פגישה",
    "CancelMeeting": "בטל פגישה",
    "InitiateEditMeeting": "יזום/ערוך פגישה",
    "Subject": "נושא",
    "Presenter": "מציג:",
    "DateTime": "תאריך ושעה",
    "TimeAndZone": "אזור זמן",
    "Attendees": "משתתפים",
    "Addrequiredattendees": "הוסף משתתפים חובה",
    "SelectRooms": "בחר חדרים",
    "Reminder": "תזכורת",
    "Remindbeforestart": "תזכיר לפני התחלה",
    "Confirm": "אשר",
    "topic": "נושא:",
    "topicplace": "כותרת פגישה חדשה:",
    "speaker": "מציג:",
    "speakerplace": "אנא הזן את פרטי המציג",
    "DateAndTime": "תאריך ושעה:",
    "TimeZone": "אזור זמן",
    "EndDate": "תאריך סיום",
    "Rooms": "חדרים:",
    "Notes": "הערות:",
    "MeetingRoomApproval": "אישור חדר פגישה",
    "PendingApproval": "בהמתנה לאישור",
    "Approved": "אושר",
    "nopendingapprovals": "אין אישורים בהמתנה",
    "Applicant": "מבקש",
    "UsageTime": "זמן שימוש",
    "ApprovalResult": "תוצאת אישור",
    "ApprovalComments": "הערות אישור",
    "Approve": "אשר",
    "Reject": "דחה",
    "Search": "חפש",
    "Filter": "סנן",
    "scanTheQRCodeToSignIn": "סרוק את קוד ה-QR כדי לחתום נוכחות"
  },
  "NPS": {
    "Relay": "חיווט מחדש",
    "RelaySettings": "הגדרות חיווט מחדש",
    "DevicePower": "בקרת כוח המכשיר",
    "DeviceElevation": "בקרת הרמה",
    "LinageWithNPSPower": "קישור עם חשמל NPS",
    "PresentationSwitch": "מתג מצגת",
    "Duplicate": "שכפול",
    "LinkagewithNPSPowe": "קישור עם חשמל NPS",
    "npsTooltip": "מכשירי USB ניתנים לקריאה רק על ידי מחשב מארח שהוחלף ל-HDMI OUT 1.",
    "nmpTooltip": "לחץ על כפתור 'שכפול' כדי לשקף את תוכן המסך על תצוגות אחרות, ולסנכרן את התצוגה על פני מסכים מרובים."
  },
  "textTemplate": {
    "template2513": "שידור חירום אש",
    "template2514": "אנא פנה למקום בטוח דרך יציאת חירום ויציאת אש בהתאם לתוכנית מילוט האש.",
    "moreTemplate": "הגעת למגבלת תבנית",
    "add": "הוסף",
    "SetTemplate": "הגדר תבנית",
    "Emergency": "חירום",
    "General": "כללי",
    "BroadcastDevices": "מכשיר שידור:",
    "selectBroadcastDevices": "אנא בחר מכשירי שידור",
    "All": "הכל",
    "AddTemplate": "הוסף תבנית",
    "EditTemplate": "ערוך תבנית",
    "deleteTemplage": "האם אתה בטוח שברצונך למחוק את התבנית שנבחרה?",
    "title": "מחק תבנית",
    "selectTemplage": "אנא בחר תבנית!",
    "DeleteCancelled": "המחיקה בוטלה!",
    "DeletedSuccessfully": "נמחק בהצלחה!",
    "noData": "אין תבנית שניתן להשתמש בה, לחץ בפינה הימנית העליונה כדי להוסיף תבנית.",
    "TemplateTitle": "כותרת התבנית:",
    "BroadcastType": "סוג השידור:",
    "BroadcastTypeDialog": "סוג השידור:",
    "selectBroadcastType": "אנא בחר סוג שידור",
    "BroadcastDuration": "משך השידור:",
    "BroadcastDevice": "מכשיר השידור:",
    "BroadcastContent": "תוכן השידור:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "שגיאה!",
    "mediaTimeStateNotifyErrorContent": "שירות הזרמת המדיה שלך פג תוקפו, אנא פנה לסוכן שלך לחדש בזמן.",
    "mediaTimeStateNotifyWarnTitle": "תשומת לב!",
    "mediaTimeStateNotifyWarnContent": "אתה נמצא כרגע במצב ניסיון, שבו ניתן לשדר ולשדר חי לכל היותר ל-3 מכשירים סופיים.",
    "mediaTimeStateNotifySuccessTitle": "חידוש מוצלח",
    "mediaTimeStateNotifySuccessContent": "שירות ההזרמה שלך מוכן לשימוש רגיל. תודה.",
    "company": "שם החברה:",
    "tableAddress": "כתובת:",
    "createTime": "תאריך יצירה:",
    "email": "אימייל:",
    "phone": "טלפון:",
    "Trial": "ניסיון",
    "TrialWorkstation": "אתה נמצא כרגע במצב ניסיון, שבו ניתן לשדר ולשדר חי לכל היותר ל-3 מכשירים סופיים.",
    "Normal": "רגיל",
    "NormalWorkstation": "תקופת השירות שלך היא מ-",
    "to": "עד",
    "Advent": "תחילת",
    "AdventWorkstationOne": "שירות ההזרמה שלך יפוג בתאריך",
    "AdventWorkstationTwo": ", אנא פנה לסוכן שלך לחדש בזמן לשימוש רגיל.",
    "Expired": "פג תוקף",
    "ExpiredWorkstation": "שירות ההזרמה שלך פג תוקפו, אנא פנה לסוכן שלך לחדש בזמן."
  },
  "route": {
    "dashboard": "לוח בקרה",
    "i18n": "I18n",
    "Devices": "מכשירים",
    "Broadcast": "שידור",
    "Schedule": "לוח זמנים",
    "Resources": "משאבים",
    "Live": "הזרמה",
    "meetings": "פגישה"
  },
  "navbar": {
    "updates": "עדכונים אחרונים",
    "logOut": "התנתק",
    "screenfull": "מסך מלא",
    "oprofile": "הפרופיל שלי",
    "settings": "הגדרות",
    "language": "שפה",
    "BackTianwa": "חזרה ל-Tianwa",
    "newUserGuide": "מדריך למשתמש חדש"
  },
  "feedback": {
    "Feedback": "משוב",
    "email": "אנא השאר את הדוא\"ל שלך לקבלת המשוב שלנו.",
    "content": "ברוכים הבאים והשארו הודעות לשיפור המוצרים שלנו. תודה על תגובותיכם.",
    "submit": "שלח",
    "emailNoEmpty": "דוא\"ל אינו יכול להיות ריק",
    "emailTrueRule": "אנא הזן פורמט דוא\"ל תקין",
    "contentNoEmpty": "התוכן אינו יכול להיות ריק",
    "feedbackSuccess": "המשוב נשלח בהצלחה",
    "feedbackFailed": "המשוב נכשל",
    "emailNoChinese": "תיבת הדואר אינה יכולה להכיל תווים סיניים",
    "emailLength": "האורך חייב להיות בין 5 ל-50 תווים",
    "emailSpecialString": "תיבת הדואר אינה יכולה להכיל מחרוזות מיוחדות"
  },
  "login": {
    checkPasswordTitleTwo: 'אנא הגדר סיסמה של לפחות 6 תווים, הכוללת אותיות ומספרים. ניתן להשתמש בתווים מיוחדים (ללא הגבלה).',
    captcha: 'קוד אימות',
    checkPasswordTitle: 'הסיסמה חייבת להכיל לפחות 6 תווים ואינה יכולה להיות רק מספרים',
    "title": "ברוך הבא",
    "logIn": "התחבר",
    "consoleLogin": "התחברות לקונסולה",
    "username": "שם משתמש",
    "password": "סיסמה",
    "any": "כל אחד",
    "thirdparty": "או התחבר עם",
    "thirdpartyTips": "לא ניתן לדמות באופן מקומי, לכן אנא שלב עם הדמיית העסק שלך!!!",
    "placeholder": "[\n  \"שם משתמש\",\n  \"סיסמה\",\n  \"קוד אימות\"\n]",
    "userNameTitle": "שם המשתמש שגוי!",
    "forget": "שכחת?",
    "loginTitle0": "התחברות הצליחה!",
    "loginTitle1000": "שם המשתמש או הסיסמה שגויים!",
    "loginTitle1001": "חובה למלא שם משתמש וסיסמה!",
    "loginTitle1002": "חובה למלא קוד אימות!",
    "loginTitle1003": "סטטוס המשתמש אינו חוקי, ההתחברות נכשלה!",
    "loginTitle1004": "שגיאת קוד אימות!",
    "loginTitle1005": "לא מחובר, אנא התחבר קודם!",
    "loginTitle1006": "שתי הסיסמאות שונות!",
    "loginTitleUserName": "חובה למלא שם משתמש!",
    "loginTitlePwd": "חובה למלא סיסמה!",
    "loginTitleVercode": "חובה למלא קוד אימות!",
    "titleLoginNameFormat": "החשבון חייב להכיל תווים, או תווים ומספרים.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "מכשירים",
    "btnRoadcast": "שידור",
    "btnResources": "משאבים",
    "btnLive": "הזרמה",
    "meetings": "פגישה",
    "todaySchedule": "לוח זמנים להיום",
    "allSkedules": "כל לוחות הזמנים",
    "details": "פרטים",
    "btnStart": "התחל",
    "titleContent": "שלום! קונסולת Q-NEX לשירותך. בוא נתחיל!",
    "btnExit": "יציאה"
  },
  "devices": {
    "ptzCamera": "מצלמת PTZ",
    "start": "התחל",
    "stop": "עצור",
    "nmpPowerOff_mandatory": "בשידור (לא חובה)",
    "nmpPowerOff_nomandatory": "בשידור (לא חובה). להמשיך בביצוע?",
    "nmpsPowerOff_mandatory": "חלק מ-NMP בשידור (חובה).",
    "nmpsPowerOff_nomandatory": "חלק מ-NMP בשידור (לא חובה). להמשיך בביצוע?",
    "reset": "איפוס",
    "displayedInTheControlArea": "מוצג במרכז הבקרה",
    "dragOrder": "סדר גרירה",
    "areaSettingTwoNotice": "*RS232, בקרת AC ושליטה מרחוק מוצגים במרכז הבקרה בהתאם למצב חיבור NMP בלוח המחוונים.",
    "areaSettingThreeNotice": "*בקרת CBX מוצגת במרכז הבקרה בהתאם למצב חיבור NMP בלוח המחוונים.",
    "controlSet": "הגדרות מרכז בקרה",
    "vcbNoLine": "אין מכשיר CBX מחובר",
    "vcbNoBound": "אין מכשיר CBX מחובר",
    "tscNoBound": "RS232 ב-TSC לא מחובר לנתונים כלשהם. נא להודיע למנהל לחבר בלוח המחוונים.",
    "light": "בקרת כוח",
    "vcbpower": "כוח",
    "rs232Control": "בקרת סידורי",


  "CBX": {
    "powerSupplyON": "הפעל כוח",
    "powerSupplyOFF": "כבה כוח",
    "lockScreenON": "נעילה מופעלת",
    "lockScreenOFF": "נעילה כבויה",
    "childLockON": "נעילת ילדים מופעלת",
    "childLockOFF": "נעילת ילדים כבויה",
    "energySavingON": "חיסכון באנרגיה מופעל",
    "energySavingOFF": "חיסכון באנרגיה כבוי",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "אנדרואיד",
    "volumeAdjustment": "רמקול",
    "brightAdjustment": "בהירות",
    "other": "תכונות נוספות…"
  },

    "InterfaceOne": "ממשק אחד",
    "InterfaceTwo": "ממשק שני",
    "abcStyleP": "מצטערים! TSC ו-(NMP, MBX, NPS, NDP100, NDP500) לא יכולים להיבחר בו זמנית",
    "masterControl": "ראשי",
    "powerSupply": "כוח",
    "RecordingControl": "בקרת הקלטה",
    "RecordingControlSystem": "מערכת לכידת הרצאות",
    "LiquidCrystal": "תצוגת LCD אינטראקטיבית",
    "projector": "מקרן",
    "othertype": "אחר",
    "lockScreen": "נעילה",
    "childLock": "נעילת ילדים",
    "energySaving": "חסכון באנרגיה",
    "signalSourceSwitching": "מקור קלט",
    "volumeAdjustment": "רמקול",
    "brightAdjustment": "בהירות",
    "other": "תכונות נוספות",
    "otherFunction": "פונקציה",
    "send": "שלח",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "מזגן",
    "titleDevices": "מסנן קבוצות:",
    "content": "חיפוש",
    "selectALL": "בחר הכל",
    "SelectRecentPage": "בחר דף נוכחי",
    "controlPanel": "מרכז בקרה",
    "displayInputSwitch": "החלפת קלט תצוגה",
    "chooseINPUTSources": "בחר מקורות קלט",
    "speakerVolume": "עוצמת שמע",
    "bass": "בס",
    "treble": "טרבל",
    "MICVolume": "עוצמת מיקרופון",
    "AirConditioning": "מזגן",
    "model": "דגם",
    "setTemp": "הגדר טמפרטורה",
    "fanSpeed": "מהירות מאוורר",
    "bold": "ניצול סווינג",
    "projectionScreen": "מסך הקרנה",
    "electronicLock": "מנעול חשמלי",
    "electronicLock1": "מנעול חשמלי",
    "selectDevices": "אנא בחר מכשיר או קבוצת מכשירים",
    "isCompelType": "בקרת מכשיר אינה זמינה עקב שידור חובה, אנא נסה שוב מאוחר יותר.",
    "mainPower": "כוח ראשי",
    "extraPower": "כוח נוסף",
    "power": "כוח",
    "hdmiBroadcast": "שידור",
    "equipmentState1": "הפעל כוח",
    "equipmentState2": "כבה כוח",
    "equipmentState3": "לא מחובר",
    "main": "ראשי",
    "external": "חיצוני",
    "ProjectionScreen": "מסך הקרנה",
    "UP": "למעלה",
    "DOWN": "למטה",
    "LOCK": "נעילה",
    "UNLOCK": "פתיחת נעילה",
    "PleaseDevice": "אנא בחר מכשיר(ים) משמאל",
    "RemoteControl": "שלט רחוק",
    "Action": "פעולה",
    "Devicefilter": "סינון מכשירים",
    "DeviceStatus": "סטטוס",
    "DeviceType": "סוג",
    "currentAudioSource": "מקור שמע נוכחי",
    "audioSwitching": "החלפת פלט שמע"
  },
  "broadcast": {
    "isBoarding": "(בשידור)",
    "last3Days": "3 הימים האחרונים",
    "last7Days": "7 הימים האחרונים",
    "last30Days": "30 הימים האחרונים",
    "historyRecord": "היסטוריה",
    "SelectDestination": "1. בחר יעד",
    "BroadcastingConsole": "2. קונסולת שידור",
    "Notification": "התראה",
    "btnStop": "עצור",
    "btnStart": "התחל",
    "Letters60": "(פחות מ-60 תווים)",
    "Letters300": "(פחות מ-300 תווים)",
    "LastingTime": "משך זמן:",
    "Title": "כותרת:",
    "Content": "תוכן:",
    "Cannotquit": "שידור חובה",
    "ChooseMedia": "בחר קובץ מדיה",
    "Broadcasting": "בשידור",
    "dialogTitle": "משאבי וידאו ושמע",
    "SortBy": "מיין לפי",
    "btnBake": "חזור לקודם",
    "cancel": "ביטול",
    "confirm": "אשר",
    "save": "שמור",
    "coxAll": "הכל",
    "PublicCloud": "אחסון ציבורי",
    "IndividualCloud": "אחסון אישי",
    "selFile": "אנא בחר קובץ או קבוצה.",
    "StopBroadcast": "עצור שידור",
    "StartBroadcasting": "התחל שידור",
    "StopBroadcasting": "עצור שידור",
    "ForceQuit": "יציאה בכוח",
    "PleaseMediaFile": "אנא בחר קובץ מדיה",
    "PleaseDevice": "אנא בחר מכשיר",
    "broadcast_0": "התחל שידור",
    "broadcast_2500": "מגיע למספר המקסימלי של מכשירים שניתן לחבר לשרת המדיה",
    "broadcast_2501": "שגיאת קובץ שידור",
    "broadcast_2502": "השידור הסתיים",
    "broadcast_2503": "לא ניתן לקבל מידע משרת המדיה",
    "broadcast_2510": "תשומת לב! אתה נמצא כרגע במצב ניסיון. עד 3 מכשירים יכולים לקבל פקודות שידור. בדוק את מספר המכשירים שבחרת.",
    "broadcast_2018": "שירות הזרמה נסגר",
    "broadcast_2019": "שירות הזרמה פג תוקפו",
    "broadcast_2512": "חרגת מהמגבלה של כמות התבניות",
    "broadcast_2513": "שידור חירום אש",
    "broadcast_2514": "אנא פנה למקום בטוח דרך יציאת חירום ויציאת אש בהתאם לתוכנית מילוט האש.",
    "broadcast_2006": "התקן לא נמצא",
    "broadcast_2": "שירות הדיסק חריג",
    "broadcast_2515": "בחר התקן שאין לו יכולות שידור",
    "broadcast_2516": "בחר קבצים החורגים מהרזולוציה המקסימלית הנתמכת על ידי NMP",
    "broadcast_2517": "בחר קבצים החורגים מהרזולוציה המקסימלית הנתמכת על ידי NDP500",
    "broadcast_Title": "התראת שידור",
    "broadcast_TitleNDP500": "התראת שידור NDP500",
    "broadcast_content": "התקן תומך עד 4K@30FPS, והרזולוציה האופטימלית היא 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 תומך עד 1080P@30FPS, והרזולוציה האופטימלית היא 720P@30FPS.",
    "broadcast_noSupported": "הסרטונים הבאים שנבחרו אינם נתמכים לשידור:",
    "broadcast_noSupportedNDP500": "הסרטונים הבאים שנבחרו אינם נתמכים לשידור על NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "שם הקובץ להעלאה לא יכול לעלות על 100 מילים!",
    "onUploadFile": "אין קבצים להעלאה",
    "open": "פתח",
    "fold": "קפל",
    "close": "סגור",
    "PublicCloud": "אחסון ציבורי",
    "IndividualCloud": "אחסון אישי",
    "TransfersHistory": "היסטוריית העברות",
    "btnDownload": "הורדה",
    "btnDelete": "מחיקה",
    "btnUploadFile": "העלה קובץ",
    "btnNewFolder": "תיקייה חדשה",
    "btnBake": "חזור לקודם",
    "coxAll": "הכל",
    "uploadError": "גודל הקובץ להעלאה לא יכול לעלות על 1G!",
    "MD5": "אמת MD5",
    "merge": "מיזוג",
    "transcoding": "טרנסקודינג",
    "uploadFailed": "ההעלאה נכשלה",
    "fileError": "שגיאת קריאת קובץ, אנא בדוק את הקובץ.",
    "tableName": "שם",
    "tableSize": "גודל",
    "tableType": "סוג",
    "tableTimeAdded": "זמן נוסף",
    "tableAction": "פעולה",
    "btnRename": "שנה שם",
    "btnMoveTo": "העבר אל...",
    "ClearAll": "נקה הכל",
    "cancel": "ביטול",
    "confirm": "אישור",
    "save": "שמור",
    "addSuccess": "הוספה בוצעה בהצלחה!",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה בוצעה בהצלחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה בוצעה בהצלחה!",
    "delError": "מחיקה נכשלה!",
    "diskError3000": "חרגת מגודל המרחב הכולל, הפעולה נכשלה!",
    "diskError3001": "חרגת מכמות השימוש במרחב הציבורי, הפעולה נכשלה!",
    "diskError3002": "חרגת מכמות השימוש במרחב האישי, הפעולה נכשלה!",
    "diskError3003": "לא ניתן למצוא את הנתונים, בדוק אם שרת המדיה מחובר!",
    "diskError3004": "שם התיקייה כבר קיים!",
    "diskError3005": "נכשל בקבלת התיקייה!",
    "diskError3006": "באותו רמה, לא ניתן ליצור יותר מ-99 תיקיות!",
    "diskError3007": "שם קובץ זהה קיים והעריכה נכשלה!",
    "diskError3008": "שם תיקייה זהה קיים והעריכה נכשלה!",
    "diskError3009": "הקובץ חורג מהמרחב הנותר וההעלאה נכשלה!",
    "diskError3010": "ההעלאה נכשלה!",
    "diskError3011": "אימות הקובץ נכשל, אנא העלה את הקובץ שוב!",
    "diskError3012": "נכשל בקבלת כתובת ענן פרטית, הפעולה נכשלה!",
    "diskError3013": "שילוב של מספר קבצים לא יכול לעלות על 100M, קבצים גדולים אנא הורד בנפרד!",
    "diskError3014": "הדחיסה נכשלה, אנא בחר מחדש את הקובץ להורדה!",
    "diskError3015": "אתה זקוק להרשאה לביצוע פעולה זו",
    "downloadError": "ההורדה נכשלה!",
    "mobileError": "ההעברה נכשלה!",
    "root": "כל הקבצים",
    "Name": "שם",
    "Size": "גודל",
    "Type": "סוג",
    "uploadFile": "העלה קובץ",
    "newFolder": "תיקייה חדשה",
    "tableTime": "זמן",
    "permission": "הרשאות לא מספקות!",
    "notifyTitle": "הודעה",
    "notifyContent": "למשתמש אין הרשאות גישה!",
    "sortFileName": "שם קובץ",
    "sortTime": "זמן",
    "sortSize": "גודל",
    "sortType": "סוג",
    "moveTo": "העבר אל",
    "test": "חדש",
    "delTitle": "למחוק?",
    "delTitleContent": "התוכן שנבחר יימחק מהמסד נתונים. הפעולה אינה ניתנת לביטול. האם אתה בטוח שברצונך להמשיך?",
    "delCancelButton": "ביטול",
    "delConfirmButton": "אישור"
  },
  "userMge": {
    "userName": "שם משתמש:",
    "jobNumber": "תעודת זהות עובד:",
    "email": "דוא\"ל:",
    "phone": "טלפון:",
    "group": "קבוצה:",
    "oldPassword": "סיסמה ישנה:",
    "newPassword": "סיסמה חדשה:",
    "confirmNewPassword": "אשר סיסמה חדשה:",
    "btnSave": "שמור שינויים",
    "titleChangePassword": "שנה סיסמה",
    "titleMyProfile": "הפרופיל שלי",
    "name": "כינוי:",
    "error1400": "החשבון (מותאם אישית) כבר קיים, הפעולה נכשלה!",
    "error1401": "החשבון (נוצר על ידי המערכת) כבר קיים, הפעולה נכשלה!",
    "error1402": "הקבוצה אינה קיימת, הייבוא נכשל!",
    "error1403": "שגיאת נתונים",
    "error1404": "הרשאות לא מספיקות",
    "selUser": "אנא בחר משתמש!",
    "error1405": "נכשל בקבלת תפקיד",
    "error1406": "פורמט הנתונים של מידע המשתמש המיובא שגוי",
    "error1407": "הדוא\"ל כבר קיים והפעולה נכשלה",
    "error1408": "הטלפון כבר קיים והפעולה נכשלה",
    "editSuccess": "נשמר בהצלחה!",
    "ChangePassword": "שנה סיסמה",
    "UserPrivacyAgreement": "מדיניות פרטיות המשתמש"
  },
  "information": {
    "_2602": "התקן לא מקוון",
    "_2603": "השידור נכשל",
    "_2604": "השידור נותק",
    "_2605": "אחסון ענן מלא",
    "_2606": "לפני דקות",
    "_2607": "לפני שעות",
    "_2609": "אירעה תקלה, אנא",
    "_2609_a": "לחץ כאן",
    "_2609_time": "לטיפול בזמן",
    "userType": "מנהל על",
    "unreadNoticeFirst": "הודעות לא נקראו קודם",
    "sortByTime": "מיין לפי זמן",
    "coxRead_1": "לא נקרא",
    "coxRead_0": "נקרא",
    "allCoxRead": "סמן הכל כנקרא",
    "load": "טוען...",
    "noData": "אין עוד נתונים",
    "viewALLMessages": "צפה בכל ההודעות"
  },
  "input": {
    "select": "אנא בחר",
    "thisField": "שדה זה חייב להיות מלא.",
    "titleShooleNub60": "פחות מ-60 תווים",
    "titleShooleNub300": "פחות מ-300 תווים",
    "Offline": "לא מקוון"
  },
  "schedule": {
    "OnlyManual": "רק ידני",
    "runStartNow": "הפעל משימה",
    "runStopNow": "עצור משימה",
    "tackExecutionStart": "משימה פועלת",
    "tackExecutionStop": "ביצוע המשימה נעצר",
    "dehumidification": "ייבוש",
    "airSupply": "אספקת אוויר",
    "masterControl": "ראשי:",
    "powerSupply": "כוח",
    "lockScreen": "נעילה",
    "RecordingControl": "בקרת הקלטה",
    "RecordingControlSystem": "מערכת לכידת הרצאה",
    "LiquidCrystal": "תצוגת LCD אינטראקטיבית",
    "projector": "מקרן",
    "othertype": "אחר",
    "childLock": "נעילת ילדים",
    "energySaving": "חיסכון באנרגיה",
    "signalSourceSwitching": "מקור קלט",
    "other": "תכונות נוספות:",
    "otherFunction": "פונקציה",
    "send": "שלח",
    "ON": "הפעל",
    "OFF": "כבה",
    "btnAddSchedule": "שחזר",
    "EditSchedulelist": "ערוך מתזמן",
    "AddSchedulelist": "הוסף מתזמן",
    "RestoreSchedulelist": "שחזר",
    "btn": "ביטול",
    "btnNewList": "מתזמן חדש",
    "ListName": "שם",
    "Cannotquit": "חובה",
    "NOCannotquit": "לא",
    "ListValidityPeriod": "תקופת תוקף",
    "ListDescription": "תיאור",
    "currentSchedule": "רשימת מתזמנים",
    "historySchedule": "רשימת היסטוריה",
    "selectTime": "זמן",
    "selectTimeTable": "זמן",
    "taskType": "סוג משימה",
    "selectBroadcasting": "שידור",
    "selectDeviveControl": "בקרת מכשיר",
    "newSchedule": "משימה חדשה",
    "newChecklist": "רשימת בדיקה חדשה",
    "titleStatus": "סטטוס",
    "titleType": "סוג",
    "titleStartTime": "שעת התחלה",
    "titleEndTime": "שעת סיום",
    "titleRepeat": "חזור על פעולה",
    "titleName": "שם",
    "titleAction": "פעולה",
    "tableEnabled": "מופעל",
    "tablePaused": "מושהה",
    "tableEdit": "ערוך",
    "tableDelete": "מחק",
    "tableVolumeEdit": "עוצמת שידור",
    "tableBroadcastTitle": "כותרת",
    "tableBroadcastContent": "תוכן",
    "tableBroadcastList": "רשימה",
    "tableBroadcast": "כפוי",
    "btnRemoveCompletely": "הסר לחלוטין",
    "btnEnabled": "משימה מופעלת",
    "btnPaused": "השבת משימה",
    "btnDelete": "מחק",
    "repeat0": "יום ב'",
    "repeat1": "יום ג'",
    "repeat2": "יום ד'",
    "repeat3": "יום ה'",
    "repeat4": "יום ו'",
    "repeat5": "יום ש'",
    "repeat6": "יום א'",
    "dialogTitleAdd": "משימת בקרת מכשיר חדשה",
    "dialogTitleEdit": "ערוך משימת בקרת מכשיר",
    "newBroadcastingSchedule": "משימת שידור חדשה",
    "editBroadcastingSchedule": "ערוך משימת שידור",
    "chooseDevice": "בחר מכשיר",
    "timeSetting": "הגדר זמן",
    "controlBroadcasting": "אפשרות שידור",
    "controlOption": "אפשרות בקרה",
    "scheduleName": "שם משימה:",
    "destination": "יעד",
    "timeTilte": "זמן",
    "repeatTitle": "חזור על פעולה",
    "dialogRepeat0": "יום ב'",
    "dialogRepeat1": "יום ג'",
    "dialogRepeat2": "יום ד'",
    "dialogRepeat3": "יום ה'",
    "dialogRepeat4": "יום ו'",
    "dialogRepeat5": "יום ש'",
    "dialogRepeat6": "יום א'",
    "dialogOnceType": "פעם אחת",
    "dialogRepeatType": "חזור על פעולה",
    "Manual": "ידני",
    "ManualContent": "ניתן להפעיל את המשימות הללו ידנית לאחר סיום ההגדרות.",
    "mainPower": "חשמל ראשי",
    "powerControl": "בקרת כוח",
    "tableDisplayInputSwitch": "החלפת קלט תצוגה",
    "tableAirConditioning": "מזגן",
    "tableProjectionScreen": "מסך הקרנה",
    "tableElectronicLock": "נעילה חשמלית",
    "interactiveFlatPanel": "Interactive Flat Panel",
    "displayInputSwitch": "החלפת קלט תצוגה",
    "speakerVolume": "עוצמת קול",
    "MICVolume": "עוצמת מיקרופון",
    "ProjectionScreen": "מסך הקרנה",
    "ElectronicLock": "נעילה חשמלית",
    "AirConditioning": "מזגן",
    "AirConditioningPower": "כוח",
    "AirConditioningModel": "דגם",
    "AirConditioningTEMP": "טמפרטורה",
    "AirConditioningFanSpeed": "מהירות מאוורר",
    "OPEN": "פתח",
    "CLOSE": "סגור",
    "UP": "למעלה",
    "DOWN": "למטה",
    "PowerOFF": "כבוי",
    "PowerON": "פעיל",
    "ModelAuto": "אוטומטי",
    "ModelCool": "קירור",
    "ModelHeat": "חימום",
    "ModelAir": "צד אוויר",
    "TEMPLow": "נמוך",
    "TEMPMiddle": "בינוני",
    "TEMPHigh": "גבוה",
    "btnSave": "שמור",
    "btnNext": "הבא",
    "StartTime": "שעת התחלה",
    "StopTime": "שעת סיום",
    "Mandatory": "חובה",
    "Video": "וידאו ואודיו",
    "Notification": "התראה",
    "btnFile": "בחר קובץ מדיה",
    "LastingTime": "משך זמן",
    "textTitle": "כותרת",
    "textContent": "תוכן",
    "textTitleLetters": "פחות מ-60 תווים",
    "textContentLetters": "פחות מ-320 תווים",
    "CannotquitYES": "כן",
    "CannotquitNo": "לא",
    "YES": "כן",
    "No": "לא",
    "delTitleContent": "האם אתה בטוח שברצונך למחוק מתזמן זה?",
    "delTitleListContent": "המתזמן שנמחק יועבר לרשימת ההיסטוריה וניתן לשחזור",
    "deleListTitle": "למחוק את המתזמן?",
    "delTitleListContent1": "מחיקת המתזמן תגרום לניקוי המשימות הקשורות אליו, נא לאשר.",
    "deleListTitle1": "האם אתה בטוח שברצונך למחוק מתזמן זה?",
    "delTitle": "למחוק?",
    "btnConfirm": "אשר",
    "coxAll": "הכל",
    "coxBroadcasting": "שידור",
    "coxDeviveControl": "בקרת מכשירים",
    "rdMandatory": "כן",
    "noRdMandatory": "לא",
    "startDate": "תאריך התחלה",
    "endedDate": "תאריך סיום",
    "or": "-",
    "broadcastingType": "סוג",
    "ChooseTime": "בחר זמן",
    "ChooseDate": "בחר תאריך",
    "newScheduleList": "מתזמן חדש",
    "editScheduleList": "ערוך מתזמן",
    "listName": "שם",
    "listValidityPeriod": "תקופת תוקף",
    "listDescription": "תיאור",
    "cancel": "ביטול",
    "confirm": "אשר",
    "save": "שמור",
    "addSuccess": "הוספה בוצעה בהצלחה!",
    "addError": "ההוספה נכשלה!",
    "editSuccess": "עריכה בוצעה בהצלחה!",
    "editError": "העריכה נכשלה!",
    "delSuccess": "המחיקה בוצעה בהצלחה!",
    "delError": "המחיקה נכשלה!",
    "restoreSuccess": "רשימת המתזמנים שוחזרה בהצלחה",
    "restoreError": "שחזור רשימת המתזמנים נכשל",
    "restoreTitleContent": "זמן זה מתנגש עם זמן מתזמן ברשימה, נא לבחור שוב",
    "Enabled": "מופעל",
    "Paused": "מושהה",
    "Title": "כותרת:",
    "Content": "תוכן:",
    "errorScheduleNameRequired": "שם המשימה חייב להיות מלא",
    "errorDeviceRequired": "אנא בחר את המכשיר היעד",
    "deleTitle": "האם אתה בטוח שברצונך למחוק משימה זו?",
    "loopList": "רשימת לולאה",
    "errorPleaseDateRange": "אנא בחר טווח תאריכים",
    "addError_2009": "שם המתזמן כפול",
    "conflicts": "זמן המשימה מתנגש עם הדברים הבאים:",
    "Pleaseagain": "אנא הזן שוב",
    "errorScheduleName": "שם משימה",
    "errorListName": "שם מתזמן",
    "today": "היום",
    "yesterday": "אתמול",
    "thisWeek": "השבוע",
    "lastWeek": "שבוע שעבר",
    "lastMonth": "חודש שעבר",
    "thisMonth": "חודש זה",
    "times": "פעמים",
    "TimeConflicts": "ניגודי זמן",
    "editError_2006": "לא נמצא מכשיר",
    "editError_2010": "שם משימה כפול",
    "editError_2100": "המשימה פגה, לא ניתן להפעיל.",
    "ListTimeExpired": "זמן המתזמן פג, נא לבחור שוב",
    "TimeExpired": "הזמן פג",
    "ControlOption": "חסר אפשרות בקרה",
    "Pleaseleastone": "אנא בחר לפחות אפשרות בקרה אחת",
    "Enter": "הזן",
    "TitleFilled": "כותרת חייבת להיות מלאה",
    "ContentFilled": "תוכן חייב להיות מלא",
    "PleaseMediaFile": "אנא בחר קובץ מדיה",
    "PleaseSchedule": "אנא בחר משימה",
    "delTitleScheduleContent": "המשימה שנמחקה לא ניתנת לשחזור.",
    "deleTitleSchedule": "האם אתה בטוח שברצונך למחוק משימה זו?",
    "deleteScheduleTitle": "אנא בחר את המשימה למחיקה",
    "PleaseFillColumn": "אנא מלא את שם המתזמן",
    "PleaseDate": "אנא בחר את התאריך",
    "Previous": "קודם",
    "RemoteControl": "שלט רחוק",
    "taskhasexpired": "משימה זו פגה, נא ליצור קשר עם היוצר לעדכון הזמן.",
    "execute": "הפעל",
    "broadcastingList": "רשימת שידורים",
    "volumeSuccess": "הגדרת עוצמת קול הצליחה",
    "volumeFailed": "הגדרת עוצמת קול נכשלה"
  },
  "live": {
    "StreamingRoom": "חדר שידור",
    "btnAddNewRoom": "הוסף חדר חדש",
    "Steaming": "שידור",
    "Creater": "מארח:",
    "Address": "כתובת RTMP:",
    "StreamingURL": "כתובת שידור חי:",
    "DestinationNMP": "בחר יעד NMP:",
    "stop": "עצור",
    "stat": "התחל",
    "btnCope": "לחץ להעתקה",
    "QRcode": "קוד QR",
    "Refresh": "רענן",
    "AddNewRoomTitle": "הוסף חדר שידור חדש",
    "editNewRoomTitle": "ערוך חדר שידור",
    "roomName": "שם החדר:",
    "cancel": "ביטול",
    "confirm": "אשר",
    "save": "שמור",
    "delTitleContent": "האם אתה בטוח שברצונך למחוק את המתזמן הזה?",
    "delTitle": "למחוק?",
    "delCancelButton": "ביטול",
    "delConfirmButton": "אשר",
    "addSuccess": "הוספה בוצעה בהצלחה!",
    "addError": "ההוספה נכשלה!",
    "editSuccess": "עריכה בוצעה בהצלחה!",
    "editError": "העריכה נכשלה!",
    "delSuccess": "המחיקה בוצעה בהצלחה!",
    "delError": "המחיקה נכשלה!",
    "Stopstreaming": "עצור שידור",
    "Startstreaming": "התחל שידור",
    "error2504": "לא ניתן לקבל את כתובת השידור החי של שרת המדיה",
    "error2505": "שם חדר השידור כפול",
    "error2506": "המכשיר תפוס על ידי אות שידור אחר",
    "error1900": "הפרמטר שאליו ניגשת ריק",
    "error2503": "לא ניתן לקבל מידע על שרת המדיה",
    "error2507": "כתובת השידור החי כפולה",
    "copySuccess": "התוכן הועתק ללוח",
    "copyError": "הדפדפן אינו תומך בהעתקה אוטומטית",
    "flashControl": "Flash אינו מותקן או אינו מופעל. אנא נסה שוב לאחר ההתקנה או הפעלת Flash.",
    "liveStreaming": "לא נמצאה מקור שידור חי.",
    "btnflash": "התקן/הפעל",
    "serverAddress": "כתובת שרת",
    "addressKey": "מפתח:",
    "watchingAddress": "כתובת צפייה",
    "audioOnly": "רק אודיו",
    "enterTheKey": "המפתח חייב להיות מלא."
  },
  "guidepages": {
    "next": "התקן הבקרה הבא",
    "next1": "נסה לשלוט הבא",
    "next2": "השידור הבא",
    "next3": "התחל שידור הבא",
    "next4": "עצור שידור הבא",
    "next5": "שידור טקסט הבא",
    "next6": "הגדרת המשימה הבאה",
    "next7": "הוסף משימה חדשה הבאה",
    "next8": "רשימת היסטוריה הבאה",
    "next9": "אחסון ענן הבא",
    "next10": "שידור חי הבא",
    "next11": "הגדר שידור חי הבא",
    "exit": "יציאה",
    "guideContent": "תוכן המדריך",
    "btnHomepage": "דף הבית",
    "btnDevices": "מכשירים",
    "btnBroadcast": "שידור",
    "btnSchedule": "לוח זמנים",
    "btnResources": "משאבים",
    "btnStreaming": "שידור",
    "btnPrevious": "קודם"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
  }
}



// WEBPACK FOOTER //
// ./src/lang/he.js